import gql from 'graphql-tag'

export default gql`query{
    filter_projects{
        project_id
        name
    }
}`